import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import FitText from "react-fittext";
import VisibiltySensor from "react-visibility-sensor";

export default class TopBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeImage: 0,
      nextImage: 0,
      intervalId: null,
    };
  }

  componentDidMount() {}
  componentWillUnmount() {
    if (typeof this.props.images !== "undefined") {
      clearInterval(this.state.intervalId);
    }
  }

  setActiveImage = () => {
    let { activeImage, nextImage } = this.state;
    const { images } = this.props;

    if (activeImage === nextImage) {
      nextImage = activeImage + 1;
    } else {
      activeImage = nextImage;
    }

    this.setState({
      activeImage: activeImage === images.length ? 0 : activeImage,
      nextImage: nextImage === images.length ? 0 : nextImage,
    });
  };

  render() {
    const {
      title,
      description,
      images,
      bannerHeight = "full",
      intervalId,
    } = this.props;
    var VisibiltySensor = require("react-visibility-sensor");

    const { activeImage, nextImage } = this.state;
    let layer1Class = "";
    if (activeImage !== nextImage) {
      layer1Class = "animate-out";
    }

    let fitSettings = {};
    if (bannerHeight === "full") {
      fitSettings = {
        compressor: 1.25,
      };
    } else {
      fitSettings = {
        maxFontSize: 100,
      };
    }
    var unloadSlider = (isVisible) => {
      if (typeof this.props.images !== "undefined") {
        if (!isVisible) {
          clearInterval(this.state.intervalId);
        } else {
          if (bannerHeight === "full") {
            this.setState({
              intervalId: setInterval(() => this.setActiveImage(), 4000),
            });
          }
        }
      }
    };

    return (
      <div className={`top-banner ${bannerHeight}`}>
        {typeof images !== "undefined" ? (
          <VisibiltySensor
            partialVisibility={true}
            onChange={(isVisible) => {
              unloadSlider(isVisible);
            }}
          >
            {bannerHeight === "full" ? (
              <div className="background-wrap">
                <div
                  id="bgLayer1"
                  key={`bg1_${activeImage}`}
                  className={`layer1 ${layer1Class}`}
                  style={{
                    backgroundImage:
                      "url(/images/banners/" + images[activeImage] + ")",
                  }}
                />
                <div
                  className={`layer2`}
                  key={`bg2_${activeImage}`}
                  style={{
                    backgroundImage:
                      "url(/images/banners/" + images[nextImage] + ")",
                  }}
                />
              </div>
            ) : (
              <div
                key={`bg_short_${activeImage}`}
                className="banner-bg"
                style={{
                  backgroundImage: "url(/images/banners/" + images[0] + ")",
                }}
              />
            )}
          </VisibiltySensor>
        ) : null}
        <div className="container-fluid d-flex align-items-center justify-content-center h-100 banner-content">
          <div className="row justify-content-center text-center w-100 align-items-center">
            <div className="col">
              <FitText compressor={1.5}>
                <h1 className="title-main" id="page-title">
                  {title}
                </h1>
              </FitText>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
